// Flat dark surface with a small status-colored icon, not MUI's filled look.
const SEVERITY_ICON_COLORS = {
  success: "#22c55e",
  error: "#ff4d4d",
  warning: "#f5a623",
  info: "#5c73ff",
};

export const toasterStyle = {
  alertStyle: (severity) => ({
    width: "100%",
    alignItems: "center",
    backgroundColor: "#17171a",
    backgroundImage: "none",
    color: "#ffffff",
    border: "1px solid #38383e",
    borderRadius: "6px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
    "& .MuiAlert-icon": {
      color: SEVERITY_ICON_COLORS[severity] || SEVERITY_ICON_COLORS.success,
      opacity: 1,
      marginRight: "10px",
      padding: 0,
      alignItems: "center",
    },
    "& .MuiAlert-icon .MuiSvgIcon-root": {
      fontSize: 18,
    },
    "& .MuiAlert-message": {
      padding: "8px 0",
      fontSize: 14,
      color: "#ffffff",
    },
    "& .MuiAlert-action": {
      paddingTop: 0,
      alignItems: "center",
      color: "rgba(255,255,255,.6)",
    },
  }),
};
